<script>
  import {
	parseNumber,
	calcPercent,
	screenshot,
	makeWebsiteRequest
  } from "../../../Common/tools";
  import EmailBuilder from "../../Popups/EmailBuilder.svelte";
  import { getEmailBuilderFeatures, makeId, sendTestEmail } from "../../static";
  import { onMount } from "svelte";
  import {External, M} from "../../../external";

  export let data;
  export let automation;
  export let stepId;
  export let automationSave;
  export let stepAdd;
  export let stepUpdate;
  export let order;
  export let valid;
  export let onChange;

  let subject = null;
  let name = null;
  let email = null;
  let receiver = null;
  let emailContent = null;
  let aligned = null;
  let defaultEmail = "";
  let thumb = "";

  const loadEmailContent = async (emailContentKey) => {
	if (emailContentKey && emailContentKey.startsWith('@')) {
	  // emailContent contains just a link to the actual content. Retrieve it.
	  let response = await makeWebsiteRequest({
		action: 'getAutomationEmailContent',
		data: {
		  key: emailContentKey
		}
	  });
	  if (response && response.data) {
		return response.data;
	  }
	}
	return emailContentKey;
  }

  const init = async () => {
	if (data && data.settings) {
	  for(let idx = 0; idx < data.settings.length; ++idx) {
      let setting = data.settings[idx];
      switch (setting.key) {
        case "aligned":
          aligned = setting.value;
          break;
        case "subject":
          subject = setting.value;
          break;
        case "name":
          name = setting.value;
          break;
        case "email":
          email = setting.value;
          break;
        case "emailContent":
          let actualEmailContent = await loadEmailContent(setting.value);
          emailContent = JSON.parse(actualEmailContent);
          break;
        case "receiver":
          receiver = setting.value;
          break;
        case "thumb":
          thumb = setting.value;
          break;
        default:
          break;
      }
    }

	  valid = subject && name && email && emailContent && receiver;
	} else if (External.Website.emailMarketingSettings) {
	  defaultEmail = External.Website.emailMarketingSettings.defaultEmail || "";
	  name = External.Website.emailMarketingSettings.defaultSender || "";
	  email = defaultEmail;
	}

	if (data && !data.id) {
	  data.reservedId = makeId(10);
	}
  }

  const onValueChange = () => {
    data.settings = [];

    data.settings.push({
      key: "aligned",
      value: aligned
    });

    data.settings.push({
      key: "subject",
      value: subject
    });

    data.settings.push({
      key: "name",
      value: name
    });

    data.settings.push({
      key: "email",
      value: email
    });

    data.settings.push({
      key: "receiver",
      value: receiver
    });

    data.settings.push({
      key: "emailContent",
      value: JSON.stringify(emailContent)
    });

    data.settings.push({
      key: "thumb",
      value: thumb
    });

    data.name = '"' + subject + '"';
    valid = subject && name && email && emailContent && receiver;
    if (emailContent) {
      onChange();
    }
  };

  function onSend() {
    sendTestEmail(emailContent, defaultEmail);
  }

  const onEditEmail = () => {
    let component;
    let emailContentChanged = false;

    External.Tools.showWindow({
      icon: External.Popup.ICON_EDIT,
      width: window.innerWidth * 0.9,
      customClass: "automation-step-email-builder",
      isModal: false,
      withDarkBackground: true,
      noTitle: true,
      forceAtRight: true, // External.showBuilderPopupsOnFullHeight,
      markup: '<div class="full-size flex flex-col f-left bind-component"></div>',
      action: {
        onShow: function (popup, context) {
          component = new EmailBuilder({
            target: context.find(".bind-component")[0],
            props: {
              parentPopup: popup,
              data: {
                content: emailContent,
                subject: subject,
                name: name,
                email: email,
                automation: automation,
                stepId: stepId || data.reservedId
              },
              features: getEmailBuilderFeatures(automation),
              automationSave: (then) => {
                automationSave(() => {
                  emailContentChanged = false;
                  then();
                });
              },
              stepAdd: stepAdd,
              stepUpdate: stepUpdate,
              order: order,
              step: data,
              onContentChange: () => {
                emailContentChanged = true;
              },
              onSaveEmail: () => {
                emailContent = component.get().content;
                emailContentChanged = false;
                onValueChange();

                makeWebsiteRequest({
                  action: 'automationEmailContentChanged',
                  method: 'post',
                  data: {
                    content: emailContent,
                    fromName: name,
                    fromEmail: email
                  }
                });

                screenshot({
                  content: emailContent,
                  automationId: automation.id,
                  stepId: stepId || data.reservedId,
                  dimensions: emailContent.style.width,
                  onReady: (filename) => {
                    thumb = External.getThumbnailsFromBase(window.getUserDir(), "emails", false) + filename + ".png?v=" + External.Tools.getTimestamp();
                    onValueChange();
                  }
                });

                popup.close();
              },
              onClose: () => {
                popup.close();
              }
            }
          });
        },
        onBeforeHide: function (popup, ui, closeAction) {
          if (emailContentChanged) {
            External.Tools.prompt(
              M.UNSAVED_CHANGES_TITLE,
              M.EMAIL_CHANGES_MADE,
              function () {
                emailContent = component.get().content;
                emailContentChanged = false;
                onValueChange();
                closeAction();
              },
              closeAction,
              M.SAVE_AND_CLOSE,
              M.UNSAVED_CHANGES_DISCARD_BTN,
              false,
              "unsaved-changes-dlg"
            );

            return false;
          }
        },
        onHide: function () {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      }
    });
  };

  let addProperty = () => {
    External.UITools.selectMarketingProperty(null, function (tag) {
      subject = (subject || "") + "{" + tag + "}";
    });
  };

  let viewFullAnalytics = () => {
    External.CPanel.goToUrl("/me/crm/marketing/automation?tab=analytics&id=" + automation.id, true);
  };

  onMount(async () => {
	await init();
    if (stepId && !thumb) {
      // old, for backwards compatibility only. Thumb URLs are now saved when the thumb is generated
      thumb = External.getThumbnailsFromBase(window.getUserDir(), "emails", false) + automation.id + "_" + (stepId || data.reservedId) + ".png?v=" + External.Tools.getTimestamp();
    }
  });
</script>

<div class="col20 f-left small-rules mb-25">
  <h4 class="col20 f-left mt-5 mb-25 t-center" style="line-height:1.4;">{M.SEND_EMAIL_NOTIFICATION}</h4>
  <span class="light-gray-text t-center col20 f-left mb-15">{M.SEND_EMAIL_NOTIFICATION_DESC}</span>
  {#if data.id && data.sent > 0}
    <div class="chart-wrapper compact-chart-wrapper col20 f-left">
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.SENT}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style="width:100%;">
            <span class="chart-label">{parseNumber(data.sent)} - 100%</span>
          </div>
        </div>
      </div>
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.OPENED}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style={"width:" + calcPercent(data.opened, data.sent) + "; background-color: #cac736"}>
            <span class="chart-label">{parseNumber(data.opened)} - {calcPercent(data.opened, data.sent)}</span>
          </div>
        </div>
      </div>
      <div class="horizontal-chart-wrapper flex align-center">
        <h4>{M.CLICKED}</h4>
        <div class="horizontal-chart-progress">
          <div class="horizontal-chart-progress-inner" style={"width:" + calcPercent(data.clicked, data.sent) + "; background-color: #cac736"}>
            <span class="chart-label">{parseNumber(data.clicked)} - {calcPercent(data.clicked, data.sent)}</span>
          </div>
        </div>
      </div>
      <!--            <div class="horizontal-chart-wrapper flex align-center"><h4>Sales</h4>-->
      <!--                <div class="horizontal-chart-progress">-->
      <!--                    <div class="horizontal-chart-progress-inner" style="width:10%; background-color: #76bd65"><span-->
      <!--                            class="chart-label">2,129 - 12.8%</span></div>-->
      <!--                </div>-->
      <!--            </div>-->
    </div>
    <div class="col20 f-left mt-5 t-center">
      <a class="middle-button blue f-none inline-block close-popup" on:click={viewFullAnalytics}>{M.VIEW_FULL_ANALYTICS}</a>
    </div>
  {/if}
  <div class="col20 f-left mt-25">
    <div class="info">
      <h5>{M.EMAIL_SUBJECT}</h5>
      <span class="light-gray-text">{M.SUBJECT_DESC}</span>
    </div>
    <div class="popup-input-wrapper">
      <div class="input-inner-wrapper input-wrapper-with-button">
        <input
          type="text"
          name="emailSubject"
          bind:value={subject}
          on:change={onValueChange}
          class="modify transition-border"
          style="margin-bottom: 5px;"
          placeholder={M.ENTER_YOUR_SUBJECT_LINE} />
        <a class="middle-button light-gray-button circle-effect add-email-tags-btn" on:click={addProperty}>{M.ADD_PROPERTY}</a>
      </div>
    </div>
  </div>

  <div class="col20 f-left">
    <div class="info">
      <h5>{M.FROM_SENDER}</h5>
      <span class="light-gray-text">{M.FROM_DESC}</span>
    </div>
    <input type="text" bind:value={name} on:change={onValueChange} class="modify transition-border half-input f-left" style="margin-bottom: 5px;" placeholder={M.SENDER_NAME} />
    <input type="text" bind:value={email} on:change={onValueChange} class="modify transition-border half-input f-right" style="margin-bottom: 5px;" placeholder={M.SENDER_EMAIL} />

    <div class="info mt-15">
      <h5>{M.RECEIVER}</h5>
      <span class="light-gray-text">{M.ENTER_EMAIL_RECEIVER}</span>
    </div>
    <div class="popup-input-wrapper">
      <input type="text" bind:value={receiver} on:change={onValueChange} class="modify transition-border" style="margin-bottom: 5px;" placeholder={M.ENTER_RECEIVER_EMAIL} />
    </div>
    {#if !emailContent}
      <div class="col20 f-left mt-5 t-center">
        <a on:click={onEditEmail} class="big-button blue f-none inline-block">{M.START_BUILDING_EMAIL}</a>
      </div>
    {:else}
      <div class="recipients-summary f-left col20 mt-5 mb-35 gray-section flex align-center">
        {#if thumb}
          <img alt="" class="system-email-box-img" src={External.content + thumb} style="margin-right: 15px;" />
        {/if}
        <div class="t-center">
          <a on:click={onSend} class="middle-button f-none inline-block light-gray-button mr-5 mb-5 rounded-effect"> {M.SEND_TEST_EMAIL} </a>
          <a on:click={onEditEmail} class="middle-button blue f-none inline-block rounded-effect"> {M.EDIT_EMAIL} </a>
        </div>
      </div>
    {/if}
  </div>
</div>
